/**
 * What a file made from illustrative data says about itself.
 *
 * Demo mode puts the sample portfolio on screen, and every screen that shows it
 * says so. A file does not: once a Print, PDF or Excel leaves the app its rows
 * read as the desk's own pipeline, to whoever opens it next. So an export built
 * from demo rows carries the mark in all three places a reader meets it: the
 * title, a notice line under it, and the filename.
 *
 * Live data is never touched: every function returns its input unchanged when
 * `demo` is false.
 */

/** The notice printed under the title of an export made from demo rows. */
export const DEMO_EXPORT_NOTICE = 'ILLUSTRATIVE DEMO DATA — not client data'

/** `[DEMO] Pipeline Report` — the title of an export made from demo rows. */
export function markDemoTitle(title: string, demo: boolean): string {
  return demo ? `[DEMO] ${title}` : title
}

/** The notice, then whatever subtitle the report already carried. */
export function markDemoSubtitle(subtitle: string, demo: boolean): string {
  if (!demo) return subtitle
  return [DEMO_EXPORT_NOTICE, subtitle.trim()].filter(Boolean).join(' · ')
}

/** `DEMO_Pipeline_lens_v1_report` — the filename of an export made from demo rows. */
export function markDemoFilename(base: string, demo: boolean): string {
  return demo ? `DEMO_${base}` : base
}
